import { render } from "./RiProdoffering162.vue?vue&type=template&id=71f5701a"
import script from "./RiProdoffering162.vue?vue&type=script&lang=js"
export * from "./RiProdoffering162.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering162.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f5701a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f5701a', __exports__)) {
    api.reload('71f5701a', __exports__)
  }
  
  module.hot.accept("./RiProdoffering162.vue?vue&type=template&id=71f5701a", () => {
    api.rerender('71f5701a', render)
  })

}


export default __exports__